import clsx from 'clsx'
import { ComponentProps, forwardRef } from 'react'

export const DialogTitle = forwardRef(function (
  props: ComponentProps<'div'>,
  ref: ComponentProps<'div'>['ref']
) {
  return (
    <div {...props} ref={ref} className={clsx('ff-rubik bold-24 txt-black-01', props.className)}>
      {props.children}
    </div>
  )
})
